import axios from 'axios';
import store from '../store';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/inventaire`;

axios.interceptors.request.use(config => {
  const state = store.getState();
  const token = state.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => Promise.reject(error));

// Old snapshot functions (kept for compatibility)
export const createSnapshot = (payload) => axios.post(`${API_BASE_URL}/snapshot`, payload);
export const recalcFromSnapshot = (payload) => axios.post(`${API_BASE_URL}/recalc`, payload);

// New EntInventaire functions
export const createInventaire = (payload) => axios.post(`${API_BASE_URL}`, payload);
export const listInventaires = (params) => axios.get(`${API_BASE_URL}`, { params });
export const recalcStockFromInventaire = (payload) => axios.post(`${API_BASE_URL}/recalc-stock`, payload);
export const getInventaireByCode = (codeInv) => axios.get(`${API_BASE_URL}/code/${codeInv}`);
export const getInventaireById = (id) => axios.get(`${API_BASE_URL}/${id}`);
export const updateInventaire = (id, payload) => axios.put(`${API_BASE_URL}/${id}`, payload);
export const validateInventaire = (id) => axios.post(`${API_BASE_URL}/${id}/validate`);
export const deleteInventaire = (id) => axios.delete(`${API_BASE_URL}/${id}`);
export const populateInventaireFromStock = (id) => axios.post(`${API_BASE_URL}/${id}/populate-stock`);
export const upsertInventaireDetail = (id, detailData) => axios.post(`${API_BASE_URL}/${id}/details`, detailData);
export const deleteInventaireDetail = (id, codeArt) => axios.delete(`${API_BASE_URL}/${id}/details/${codeArt}`);

// Import/seed inventaire details from file
export const importInventaireDetails = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_BASE_URL}/${id}/seed/upload-details`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};







